import React from 'react'
import styled from 'styled-components'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import ripIcon from '../../../assets/ripIcon.png'

const getDurationFormat = ms => {
    const minutes = Math.floor(ms / 1000 / 60)
    const seconds = Math.floor((ms - (minutes * 60 * 1000)) / 1000)
    const decis = Math.floor((ms - (minutes * 60 * 1000) - (seconds * 1000)) / 100)
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}.${decis}`
}

const SliderContainer = styled.div`
    position: relative;

    @media (max-width: 700px) {
        grid-column: 2;
    }
`

const StyledSlider = styled(Slider)`
    padding-top: 5px;
    margin-top: 12px;
`

const TimePositionedElement = styled.div.attrs({
    style: ({ value, durationSeconds }) => ({
        left: `${value / (durationSeconds * 1000) * 100}%`,
    }),
})

const Tooltip = TimePositionedElement`
    position: absolute;
    top: -8px;
    font-size: 12px;
    margin-left: -35px;
    width: 70px;
    text-align: center;
`

const HoverableTimePositionedElement = TimePositionedElement`
    &:hover:before {
        display: block;
        position: absolute;
        font-size: 12px;
        top: -35px;
        background-color: white;
        white-space: nowrap;
        border: 1px solid var(--grey-1);
        border-radius: 3px;
        transform: translateX(-50%);
        background: var(--grey-0);
        padding: 2px 6px;
    }
`

const DeathMarker = HoverableTimePositionedElement.extend`
    position: absolute;
    top: 26px;
    margin-left: -10px;
    width: 19px;
    height: 19px;
    background: url('${ripIcon}');
    background-size: 19px;
    background-repeat: no-repeat;
    filter: invert(.9);

    &:after {
        content: "";
        display: block;
    }

    &:hover:before {
        filter: invert(1.1);
        content: "Killed By: ${props => props.killerName}";
    }
`

class TimeSlider extends React.PureComponent {
    render() {
        const { value, stopAutoplay, onChange, durationSeconds, globalState } = this.props

        return (
            <SliderContainer>
                <StyledSlider
                    min={1000}
                    max={durationSeconds * 1000}
                    step={100}
                    onChange={onChange}
                    onBeforeChange={stopAutoplay}
                    value={value}
                />
                <Tooltip value={value} durationSeconds={durationSeconds}>{getDurationFormat(value)}</Tooltip>
                {globalState && globalState.death && value >= globalState.death.msSinceEpoch &&
                    <DeathMarker
                        value={globalState.death.msSinceEpoch}
                        durationSeconds={durationSeconds}
                        killerName={globalState.death.killedBy}
                    />
                }
            </SliderContainer>
        )
    }
}

export default TimeSlider



// WEBPACK FOOTER //
// ./src/components/MatchPlayer/Time/TimeSlider.js